// Left corner popup (resources/views/partials/left-popup.twig).
// Dismissable per-tab via sessionStorage — cleared when the tab is closed.
document.addEventListener('alpine:init', () => {
    window.Alpine.data('leftPopup', () => ({
        step: 1,
        open: true,
        closing: false,
        sending: false,
        error: '',
        storageKey: 'cg_left_popup_dismissed',
        init() {
            if (sessionStorage.getItem(this.storageKey)) {
                this.open = false;
            }

            // reCAPTCHA hands the token to a global callback, which re-broadcasts it here.
            document.addEventListener('cg-left-popup-token', (event) => {
                this.send(event.detail.token);
            });
        },
        dismiss() {
            this.closing = true;
            sessionStorage.setItem(this.storageKey, '1');
            setTimeout(() => (this.open = false), 300);
        },
        // Posts to the same InfusionSoft endpoint the Email Signup Card uses. inf_ajax=1
        // makes it answer with JSON instead of redirecting, so the popup can stay open.
        async send(token) {
            const form = this.$refs.infForm;

            if (!form || this.sending) {
                return;
            }

            if (!form.reportValidity()) {
                return;
            }

            this.error = '';
            this.sending = true;

            const body = new FormData(form);
            body.set('g-recaptcha-response', token);

            try {
                const response = await fetch(form.action, {
                    method: 'POST',
                    body,
                    credentials: 'same-origin',
                });
                const result = await response.json();

                if (result && result.success) {
                    this.step = 3;
                } else {
                    this.error = 'We could not verify that submission. Please try again.';
                }
            } catch (e) {
                this.error = 'Something went wrong. Please try again.';
            } finally {
                this.sending = false;
                if (window.grecaptcha) {
                    window.grecaptcha.reset();
                }
            }
        },
    }));
});

window.onSubmitLeftPopup = (token) => {
    document.dispatchEvent(new CustomEvent('cg-left-popup-token', { detail: { token } }));
};

// app.js is site-wide, so only pull in reCAPTCHA where the popup form is really rendered —
// and not at all where the Email Signup Card has already loaded api.js for itself.
document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.popup-inf-form')) {
        return;
    }

    if (document.querySelector('script[src*="recaptcha/api.js"]')) {
        return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
});
